import { render, staticRenderFns } from "./CmgLoyaltyProgressBar.vue?vue&type=template&id=6a2d1916&scoped=true&lang=pug&"
import script from "./cmg-loyalty-progress-bar.ts?vue&type=script&lang=ts&"
export * from "./cmg-loyalty-progress-bar.ts?vue&type=script&lang=ts&"
import style0 from "./CmgLoyaltyProgressBar.vue?vue&type=style&index=0&id=6a2d1916&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2d1916",
  null
  
)

export default component.exports